// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.foot-desc-txt {
  margin-top: 22px;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-size: 14px;
  line-height: 28px;
  color: #5f6b73;
}

.sns-context {
  margin-top: 25px;
  width: 150px;
  display: flex;
  justify-content: space-between;
  opacity: 0.7;
}

.sns-context img {
    cursor: pointer;
    transition: transform 0.3s ease;
}

.sns-context img:hover {
    transform: translateY(-3px);
}

.foot-category-title {
  font-family: "Playfair Display", serif; /* Luxury font */
  font-weight: 600;
  font-size: 22px;
  letter-spacing: 1px;
  color: #b88a44;
  margin-bottom: 10px;
}

.foot-category-link {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: "Poppins", sans-serif;
  font-size: 15px;
}

.foot-category-link a {
  color: #f4f1ea;
  text-decoration: none;
  transition: color 0.3s ease;
  opacity: 0.8;
}

.foot-category-link a:hover {
  color: #b88a44;
  opacity: 1;
}

.find-us {
  display: flex;
  margin-bottom: 15px;
}

.find-us span {
  font-family: "Playfair Display", serif;
  font-weight: 700;
  font-size: 16px;
  color: #b88a44;
}

.find-us div {
  margin-left: 12px;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-size: 14px;
  color: #f4f1ea;
  opacity: 0.8;
}

.copyright-txt {
  margin-top: 25px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  letter-spacing: 1px;
  color: #5f6b73;
}

/* Luxury Underline Effect */
.foot-category-title:after {
  display: block;
  content: "";
  border-bottom: solid 1px #b88a44;
  width: 30px;
  margin-top: 5px;
}

/* Homepage-aligned footer refinement */
.site-footer {
  height: auto !important;
  min-height: 0;
  padding: 60px 0 28px;
  background: #0a1824 !important;
  border-top: 0 !important;
}

.site-footer .footer-main {
  margin-top: 0 !important;
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(420px, 1.15fr);
  gap: clamp(72px, 10vw, 150px);
  align-items: start;
}

.site-footer .footer-brand {
  width: auto !important;
  max-width: 390px;
}

.site-footer .footer-brand > div:first-child img {
  width: 112px;
  height: auto;
  opacity: 0.9;
}

.site-footer .foot-desc-txt {
  margin-top: 22px;
  max-width: 370px;
  color: #5f6b73;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.85;
  letter-spacing: 0.01em;
}

.site-footer .sns-context {
  width: auto;
  margin-top: 24px;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  opacity: 1;
}

.site-footer .sns-context img {
  box-sizing: content-box;
  width: 16px;
  height: 16px;
  padding: 9px;
  border: 1px solid rgba(95, 107, 115, 0.18);
  border-radius: 3px;
  background: #0a1824;
  opacity: 0.68;
  filter: grayscale(1) brightness(1.35) !important;
  transition: transform 250ms ease, opacity 250ms ease, border-color 250ms ease;
}

.site-footer .sns-context img:hover {
  transform: translateY(-2px);
  opacity: 0.95;
  border-color: rgba(184, 138, 68, 0.3);
}

.site-footer .footer-columns {
  margin-left: 0 !important;
  display: grid;
  grid-template-columns: minmax(130px, 0.7fr) minmax(250px, 1.3fr);
  gap: clamp(52px, 7vw, 96px);
}

.site-footer .footer-boutique {
  margin-left: 0 !important;
}

.site-footer .foot-category-title {
  margin-bottom: 20px;
  color: #b88a44;
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.2em;
  text-transform: uppercase;
}

.site-footer .foot-category-title::after {
  width: 24px;
  margin-top: 9px;
  border-bottom-color: rgba(184, 138, 68, 0.5);
}

.site-footer .foot-category-link {
  margin-top: 0 !important;
  gap: 11px;
  color: #5f6b73;
  font-size: 13px;
  line-height: 1.6;
}

.site-footer .foot-category-link a {
  width: fit-content;
  color: #5f6b73;
  opacity: 1;
  transition: color 220ms ease, transform 220ms ease;
}

.site-footer .foot-category-link a:hover {
  color: #f4f1ea;
  transform: translateX(2px);
}

.site-footer .find-us {
  min-height: 24px;
  margin-bottom: 8px;
  align-items: baseline;
}

.site-footer .find-us span {
  width: 18px;
  flex: 0 0 18px;
  color: #b88a44;
  font-family: "Poppins", sans-serif;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.08em;
}

.site-footer .find-us div {
  margin-left: 8px;
  color: #5f6b73;
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.6;
  opacity: 1;
}

.site-footer .footer-rule {
  margin-top: 58px !important;
  border: 0 !important;
  border-top: 1px solid rgba(95, 107, 115, 0.16) !important;
  opacity: 1 !important;
}

.site-footer .copyright-txt {
  margin-top: 22px;
  color: #5f6b73;
  font-family: "Poppins", sans-serif;
  font-size: 10px;
  line-height: 1.6;
  letter-spacing: 0.1em;
  text-align: center;
}

@media (max-width: 900px) {
  .site-footer {
    padding-top: 54px;
  }

  .site-footer .footer-main {
    grid-template-columns: 1fr;
    gap: 48px;
  }

  .site-footer .footer-columns {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .site-footer .footer-columns {
    grid-template-columns: 1fr;
    gap: 36px;
  }

  .site-footer .footer-rule {
    margin-top: 44px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/footer.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;EACE,sCAAsC,EAAE,gBAAgB;EACxD,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,WAAW;EACX,gCAAgC;EAChC,WAAW;EACX,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,+DAA+D;EAC/D,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gEAAgE;EAChE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".foot-desc-txt {\n  margin-top: 22px;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 28px;\n  color: #5f6b73;\n}\n\n.sns-context {\n  margin-top: 25px;\n  width: 150px;\n  display: flex;\n  justify-content: space-between;\n  opacity: 0.7;\n}\n\n.sns-context img {\n    cursor: pointer;\n    transition: transform 0.3s ease;\n}\n\n.sns-context img:hover {\n    transform: translateY(-3px);\n}\n\n.foot-category-title {\n  font-family: \"Playfair Display\", serif; /* Luxury font */\n  font-weight: 600;\n  font-size: 22px;\n  letter-spacing: 1px;\n  color: #b88a44;\n  margin-bottom: 10px;\n}\n\n.foot-category-link {\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 15px;\n}\n\n.foot-category-link a {\n  color: #f4f1ea;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  opacity: 0.8;\n}\n\n.foot-category-link a:hover {\n  color: #b88a44;\n  opacity: 1;\n}\n\n.find-us {\n  display: flex;\n  margin-bottom: 15px;\n}\n\n.find-us span {\n  font-family: \"Playfair Display\", serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #b88a44;\n}\n\n.find-us div {\n  margin-left: 12px;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 300;\n  font-size: 14px;\n  color: #f4f1ea;\n  opacity: 0.8;\n}\n\n.copyright-txt {\n  margin-top: 25px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 13px;\n  letter-spacing: 1px;\n  color: #5f6b73;\n}\n\n/* Luxury Underline Effect */\n.foot-category-title:after {\n  display: block;\n  content: \"\";\n  border-bottom: solid 1px #b88a44;\n  width: 30px;\n  margin-top: 5px;\n}\n\n/* Homepage-aligned footer refinement */\n.site-footer {\n  height: auto !important;\n  min-height: 0;\n  padding: 60px 0 28px;\n  background: #0a1824 !important;\n  border-top: 0 !important;\n}\n\n.site-footer .footer-main {\n  margin-top: 0 !important;\n  display: grid;\n  grid-template-columns: minmax(280px, 1fr) minmax(420px, 1.15fr);\n  gap: clamp(72px, 10vw, 150px);\n  align-items: start;\n}\n\n.site-footer .footer-brand {\n  width: auto !important;\n  max-width: 390px;\n}\n\n.site-footer .footer-brand > div:first-child img {\n  width: 112px;\n  height: auto;\n  opacity: 0.9;\n}\n\n.site-footer .foot-desc-txt {\n  margin-top: 22px;\n  max-width: 370px;\n  color: #5f6b73;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  line-height: 1.85;\n  letter-spacing: 0.01em;\n}\n\n.site-footer .sns-context {\n  width: auto;\n  margin-top: 24px;\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n  opacity: 1;\n}\n\n.site-footer .sns-context img {\n  box-sizing: content-box;\n  width: 16px;\n  height: 16px;\n  padding: 9px;\n  border: 1px solid rgba(95, 107, 115, 0.18);\n  border-radius: 3px;\n  background: #0a1824;\n  opacity: 0.68;\n  filter: grayscale(1) brightness(1.35) !important;\n  transition: transform 250ms ease, opacity 250ms ease, border-color 250ms ease;\n}\n\n.site-footer .sns-context img:hover {\n  transform: translateY(-2px);\n  opacity: 0.95;\n  border-color: rgba(184, 138, 68, 0.3);\n}\n\n.site-footer .footer-columns {\n  margin-left: 0 !important;\n  display: grid;\n  grid-template-columns: minmax(130px, 0.7fr) minmax(250px, 1.3fr);\n  gap: clamp(52px, 7vw, 96px);\n}\n\n.site-footer .footer-boutique {\n  margin-left: 0 !important;\n}\n\n.site-footer .foot-category-title {\n  margin-bottom: 20px;\n  color: #b88a44;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n}\n\n.site-footer .foot-category-title::after {\n  width: 24px;\n  margin-top: 9px;\n  border-bottom-color: rgba(184, 138, 68, 0.5);\n}\n\n.site-footer .foot-category-link {\n  margin-top: 0 !important;\n  gap: 11px;\n  color: #5f6b73;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.site-footer .foot-category-link a {\n  width: fit-content;\n  color: #5f6b73;\n  opacity: 1;\n  transition: color 220ms ease, transform 220ms ease;\n}\n\n.site-footer .foot-category-link a:hover {\n  color: #f4f1ea;\n  transform: translateX(2px);\n}\n\n.site-footer .find-us {\n  min-height: 24px;\n  margin-bottom: 8px;\n  align-items: baseline;\n}\n\n.site-footer .find-us span {\n  width: 18px;\n  flex: 0 0 18px;\n  color: #b88a44;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0.08em;\n}\n\n.site-footer .find-us div {\n  margin-left: 8px;\n  color: #5f6b73;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 13px;\n  font-weight: 300;\n  line-height: 1.6;\n  opacity: 1;\n}\n\n.site-footer .footer-rule {\n  margin-top: 58px !important;\n  border: 0 !important;\n  border-top: 1px solid rgba(95, 107, 115, 0.16) !important;\n  opacity: 1 !important;\n}\n\n.site-footer .copyright-txt {\n  margin-top: 22px;\n  color: #5f6b73;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 10px;\n  line-height: 1.6;\n  letter-spacing: 0.1em;\n  text-align: center;\n}\n\n@media (max-width: 900px) {\n  .site-footer {\n    padding-top: 54px;\n  }\n\n  .site-footer .footer-main {\n    grid-template-columns: 1fr;\n    gap: 48px;\n  }\n\n  .site-footer .footer-columns {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 560px) {\n  .site-footer .footer-columns {\n    grid-template-columns: 1fr;\n    gap: 36px;\n  }\n\n  .site-footer .footer-rule {\n    margin-top: 44px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
